import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight, Target, RefreshCw, ClipboardCheck } from "lucide-react"
import SEO from "../components/SEO.jsx"
import PageHero from "../components/page/PageHero.jsx"
import ServicesGrid from "../components/home/ServicesGrid.jsx"
import SectionHeading from "../components/home/SectionHeading.jsx"
import FinalCTA from "../components/home/FinalCTA.jsx"

// Website packages and add-ons are intentionally not shown here
// (REPOSITIONING-PLAN.md amendment A1 / Stage 4 decision 1).

const ENGAGEMENTS = [
  {
    icon: Target,
    title: "Defined projects",
    text: "A new website, an integration or an SEO overhaul, scoped clearly with a tailored quote before work begins.",
  },
  {
    icon: RefreshCw,
    title: "Ongoing partnership",
    text: "Continuous improvement across your website, search and AI visibility and campaigns, with priorities agreed together.",
  },
  {
    icon: ClipboardCheck,
    title: "Start with a review",
    text: "Not sure where to begin? A review of your current presence shows what is working and what to tackle first.",
  },
]

export default function Services() {
  return (
    <div className="bg-white text-brand-text">
      <SEO
        title="Digital Services for Established Businesses | 2merative"
        description="Premium websites, SEO & GEO, Google Ads, integrations, AI chatbots, digital strategy and ongoing support for established businesses in Adelaide and beyond."
        path="/services"
        image="/og-image.png"
      />

      <PageHero
        eyebrow="Services"
        title="Services built around business growth"
        lead="From strategy and website development to search and AI visibility, advertising, AI chatbots and connected systems, we help established businesses get more from their digital presence."
      />

      <ServicesGrid
        eyebrow="What we do"
        title="Six ways we help your business grow online"
        lead="Engage us for one service or combine them. SEO & GEO, Google Ads, AI chatbots and ongoing support are all available without a new website."
      />

      <section aria-labelledby="engagement-heading" className="bg-brand-bg py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <SectionHeading
            id="engagement-heading"
            eyebrow="Ways to work with us"
            title="Flexible engagement, one accountable team"
          />

          <ul className="mt-10 grid gap-6 lg:grid-cols-3">
            {ENGAGEMENTS.map(({ icon: Icon, title, text }) => (
              <li key={title} className="flex flex-col rounded-xl2 border border-brand-border bg-white p-7 shadow-card">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-primarySoft text-brand-primary">
                  <Icon aria-hidden="true" className="h-6 w-6" />
                </span>
                <h3 className="mt-5 text-xl font-semibold text-brand-heading">{title}</h3>
                <p className="mt-3 leading-relaxed text-brand-textSoft">{text}</p>
              </li>
            ))}
          </ul>

          <div className="mt-8">
            <Link
              to="/industries"
              className="inline-flex items-center gap-2 font-semibold text-brand-primary hover:underline"
            >
              See the industries we work with
              <ArrowRight aria-hidden="true" className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  )
}
